/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Price_TotalInputs */

const en_admin_resource_form_price_total = /** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price (total)`)
};

const de_admin_resource_form_price_total = /** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const es_admin_resource_form_price_total = /** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_admin_resource_form_price_total = /** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

/** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */
const it_admin_resource_form_price_total = en_admin_resource_form_price_total;

/** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */
const pt_br2_admin_resource_form_price_total = en_admin_resource_form_price_total;

/** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */
const pl_admin_resource_form_price_total = en_admin_resource_form_price_total;

/** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */
const hu_admin_resource_form_price_total = en_admin_resource_form_price_total;

/** @type {(inputs: Admin_Resource_Form_Price_TotalInputs) => LocalizedString} */
const ro_admin_resource_form_price_total = en_admin_resource_form_price_total;

/**
* | output |
* | --- |
* | "Price (total)" |
*
* @param {Admin_Resource_Form_Price_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_price_total = /** @type {((inputs?: Admin_Resource_Form_Price_TotalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Price_TotalInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_price_total(inputs)
	if (locale === "de") return de_admin_resource_form_price_total(inputs)
	if (locale === "es") return es_admin_resource_form_price_total(inputs)
	if (locale === "fr") return fr_admin_resource_form_price_total(inputs)
	if (locale === "it") return it_admin_resource_form_price_total(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_price_total(inputs)
	if (locale === "pl") return pl_admin_resource_form_price_total(inputs)
	if (locale === "hu") return hu_admin_resource_form_price_total(inputs)
	return ro_admin_resource_form_price_total(inputs)
});
export { admin_resource_form_price_total as "admin.resource_form.price_total" }